import axios from 'axios'

import AuthService from '@/shared/services/auth-service'

const axiosInstance = axios.create({
  baseURL: import.meta.env.REACT_APP_BASE_URL,
  timeout: 60000
})

axiosInstance.interceptors.request.use(
  (config) => {
    const token = AuthService.getUser()?.accessToken

    if (token && config.headers) {
      const persona = AuthService.getPersona()
      config.headers['Authorization'] = 'Bearer ' + token // for Spring Boot back-end
      config.headers['X-CompanyID'] = persona?.companyId
      config.headers['X-PersonaID'] = persona?.personaId
      config.headers['X-PersonaType'] = persona?.personaType
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  (res) => {
    return res
  },
  async (err) => {
    const originalConfig = err.config

    if (originalConfig.url !== '/login' && err.response) {
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true

        try {
          const rs = await axiosInstance.post('/v1/token/refresh', {
            refreshToken: AuthService.getUser()?.refreshToken
          })

          const { accessToken } = rs.data
          AuthService.setUser({ accessToken })

          return axiosInstance(originalConfig)
        } catch (_error) {
          return Promise.reject(_error)
        }
      }
    }

    return Promise.reject(err)
  }
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const customAxiosWithoutInterceptor: any = {}

Object.assign(customAxiosWithoutInterceptor, axiosInstance)
const methods = ['get', 'post', 'put', 'patch', 'delete']
for (const method of methods) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customAxiosWithoutInterceptor[method] = async (...args: any) => {
    try {
      const response = await axiosInstance[method](...args)
      return [response, null]
    } catch (error) {
      return [null, error]
    }
  }
}
export default customAxiosWithoutInterceptor
